import { Link } from 'react-router-dom';
import { Minus, Plus, PlusCircle, Package } from 'lucide-react';
import { motion } from 'framer-motion';
// import LastMinuteAddOns from '@/components/cart/LastMinuteAddOns';

const CartItems = ({ cart, updateQuantity, navigateToStore }) => {
  // const handleAddOnItemClick = (item) => {
  //   // Implement add-on item addition logic
  //   console.log('Adding add-on item:', item);
  // };

  return (
    <div className="bg-gray-50">
      <div className="p-4 border-b bg-white rounded-t-lg">
        <div className="flex justify-between items-center mb-3">
          <h2 className="font-semibold flex items-center gap-2 text-gray-800">
            <Package className="w-5 h-5 text-green-600" />
            Your Basket{' '}
            <span className="text-sm bg-green-100 text-green-800 px-2 py-0.5 rounded-full">
              {cart.length}
            </span>
          </h2>
          <button
            onClick={navigateToStore}
            className="px-3 py-1.5 bg-green-50 text-green-600 rounded-full text-sm font-medium flex items-center transition-all hover:bg-green-100"
          >
            <PlusCircle className="w-4 h-4 mr-1.5" />
            Add More
          </button>
        </div>

        {cart.length === 0 ? (
          <div className="py-8 flex flex-col items-center justify-center">
            <div className="p-4 bg-green-50 rounded-full mb-3">
              <Package className="h-10 w-10 text-green-500" />
            </div>
            <p className="text-gray-500 text-center mb-3">Your cart is empty</p>
            <Link to="/store" className="px-4 py-2 bg-green-500 text-white rounded-lg font-medium">
              Start Shopping
            </Link>
          </div>
        ) : (
          <div className="space-y-3">
            {cart.map((item) => (
              <CartItem
                key={`${item.id}-${item.variant.inventoryId}`}
                item={item}
                updateQuantity={updateQuantity}
              />
            ))}
          </div>
        )}
      </div>

      {/* <LastMinuteAddOns items={addOnItems} onAddItem={handleAddOnItemClick} /> */}
    </div>
  );
};

const CartItem = ({ item, updateQuantity }) => {
  const showDiscount = item.mrp > item.price;
  const discountPercentage = Math.round(((item.mrp - item.price) / item.mrp) * 100);

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex items-center p-2.5 bg-white rounded-lg border border-gray-100 hover:border-green-100"
    >
      <div className="flex gap-3 w-full items-center">
        <div className="relative w-16 h-16 overflow-hidden rounded-lg bg-gray-50 flex-shrink-0">
          <img
            loading="lazy"
            src={item.image || `/images/${item.name.toLowerCase()}.png`}
            alt={item.name}
            className="w-full h-full object-cover"
          />
          {showDiscount && (
            <div className="absolute top-0 left-0 bg-red-500 text-white text-xs px-1.5 py-0.5 rounded-br-lg font-medium">
              {discountPercentage}% OFF
            </div>
          )}
        </div>

        <div className="flex-1">
          <div className="flex flex-col h-full justify-between">
            <div className="flex items-start gap-1 justify-between">
              <div>
                <h3 className="font-medium text-gray-800 line-clamp-1">{item.name}</h3>
                <p className="text-sm text-gray-500 mt-0.5">
                  {item.variant.variant === '0' ? 'Net price ₹' : ''}
                  <>
                    {item.variant.variant !== '0' ? item.variant.variant : item?.price}{' '}
                    {item.variant.unit}
                  </>
                </p>
              </div>
              <div className="flex flex-col gap-2 items-center justify-between">
                <div className="flex flex-row items-center gap-1">
                  <span className="font-semibold text-gray-800">
                    ₹{Math.ceil(item.price * item.quantity)}
                  </span>
                  {showDiscount && (
                    <span className="text-sm text-gray-500 line-through">
                      ₹{Math.ceil(item.mrp * item.quantity)}
                    </span>
                  )}
                </div>

                <div className="flex items-center bg-green-500 text-white rounded-lg overflow-hidden">
                  <button
                    onClick={() => updateQuantity(item.id, item.variant.inventoryId, -1)}
                    className="p-1.5 transition-colors hover:bg-green-600 active:bg-green-700"
                    aria-label="Decrease quantity"
                  >
                    <Minus size={16} />
                  </button>
                  <span className="px-2 font-medium min-w-[24px] text-center">{item.quantity}</span>
                  <button
                    onClick={() => {
                      if (item.quantity < 9) {
                        updateQuantity(item.id, item.variant.inventoryId, 1);
                      }
                    }}
                    className="p-1.5 transition-colors hover:bg-green-600 active:bg-green-700"
                    aria-label="Increase quantity"
                    disabled={item.quantity >= 9}
                  >
                    <Plus size={16} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default CartItems;
